import * as React from 'react';
import styled from 'styled-components';
import { UserToken } from '../../../amorg-common';
import { Footer } from './elements/Footer';

export type UserLayoutProps = React.PropsWithChildren<{
    activeUser: UserToken,
}>

export const UserLayout = ({ activeUser, children }: UserLayoutProps) => {

    return (
        <Main>
            <CoreContent className="mainContent">
                {children}
            </CoreContent>

            <Footer siteId={activeUser.siteId} />
        </Main>
    )
};

const Main = styled.div`
    display:grid;
    min-height: 100%;
    grid-template-rows: auto min-content;
    grid-template-areas:
        "content"
        "footer";
`;

const CoreContent = styled.div`
    
    position: relative;
    z-index: 10;
    grid-area: content;

    width:100%;
    margin: 32px auto 10px auto;
    max-width:90%;
`;
